"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Provider = void 0;
var Provider;
(function (Provider) {
    Provider["BPOST"] = "BPOST";
    Provider["POSTNL"] = "POSTNL";
    Provider["ROYAL_MAIL"] = "ROYAL_MAIL";
})(Provider || (exports.Provider = Provider = {}));
//# sourceMappingURL=ProviderEnums.js.map